import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_DEVICES } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteChargingDevicesAPI: any = createAsyncThunk(
  "deleteChargingDevices",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(CHARGING_DEVICES + "/" + rowId, {
        headers: commonHead,
      });
      return { chargingDeviceDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
